var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.data),expression:"data"}],attrs:{"id":"content-editor"},domProps:{"value":(_vm.data)},on:{"input":function($event){if($event.target.composing)return;_vm.data=$event.target.value}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }